import { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Dayjs } from "@/utils/dayjsConfig";
import { CustomDatePickerFunc } from "@/utils/commonConfig";

export const useOmsDatePicker = () => {
  const { t } = useTranslation();
  const currentDate = useMemo(() => new Date(), []);
  const [offTime, setOffTime] = useState<Dayjs>();
  const [onTime, setOnTime] = useState<Dayjs>();

  const getOfftime = useMemo(() => {
    let tempDate = undefined;
    if (onTime) {
      const cDate = new Date(onTime?.toDate());
      tempDate = new Date(cDate.setDate(cDate.getDate() - 1));
    }
    return CustomDatePickerFunc({
      name: "offAt",
      label: t("schOff"),
      minDate: currentDate,
      maxDate: tempDate,
      onChange(val) {
        setOffTime(val);
      },
    });
  }, [currentDate, t, onTime]);

  const getOntime = useMemo(() => {
    const cDate = new Date(offTime ? offTime?.toDate() : currentDate);
    const tempDate = new Date(cDate.setDate(cDate.getDate() + 1));
    return CustomDatePickerFunc({
      name: "onAt",
      label: t("schOn"),
      minDate: tempDate,
      onChange(val) {
        setOnTime(val);
      },
    });
  }, [currentDate, t, offTime]);

  return { getOfftime, getOntime, offTime, onTime, setOffTime, setOnTime };
};

export default useOmsDatePicker;
